import { render, staticRenderFns } from "./WestNileVirus_Municipality.vue?vue&type=template&id=a55a8480"
import script from "./WestNileVirus_Municipality.vue?vue&type=script&lang=js"
export * from "./WestNileVirus_Municipality.vue?vue&type=script&lang=js"
import style0 from "./WestNileVirus_Municipality.vue?vue&type=style&index=0&id=a55a8480&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports